import React from 'react'
import { Box, Typography, Divider } from '@mui/material'

export default function AboutUs() {
  return (
    <Box
      id='aboutus'
      height={{ xs: 700, md: 800 }}
      color={'#FFFFFF'}
      sx={{
        backgroundColor: 'black',
        backgroundImage: 'url("/assets/AboutUsBackground.png")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Box
        maxWidth={{ xs: 300, sm: 320, md: 400, lg: 500 }}
        pt={{ xs: 15, sm: 20, md: 25 }}
        px={{ xs: 8, sm: 15, md: 18 }}
      >
        <Typography
          fontSize={{ xs: '2rem', sm: '2.5rem', lg: '3rem' }}
          fontFamily={'CorsicaLXBold'}
          lineHeight={1}
          fontWeight={'bold'}
        >
          ABOUT US
        </Typography>
        <Divider
          sx={{
            width: '75%',
            height: 4,
            backgroundColor: '#fff',
            marginY: 2,
          }}
        />
        <Typography fontSize={{ xs: '1rem', sm: '1.2rem', lg: '1.4rem' }}>
          Trusted since 1989, we've grown from a small retail shop in Joo Chiat to a reputable tyre
          distributor in Singapore. Our success is built on a foundation of excellence,
          collaboration, and a shared commitment to progress with our customers, staff, and
          suppliers.
        </Typography>
        <Typography
          fontSize={{ xs: '1.5rem', sm: '1.8rem', lg: '2rem' }}
          fontFamily={'CorsicaLXBold'}
          component='a'
          href='https://htgroup.com.sg/'
          color={'#FFFFFF'}
          style={{ textDecoration: 'none' }}
        >
          {'Discover HT >'}
        </Typography>
      </Box>
    </Box>
  )
}
